<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-05 20:12:32
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-20 11:22:38
-->
<template>
	<div style="float: left" class="flex pl-4">
		<div class="footer-img ml-6 mr-6">
			<yx-avatar :src="item.head" :size="60"></yx-avatar>
		</div>
		<div>
			<div class="flex flex-row-align-center">
				<platform-icon style="flex-shrink: 0" :platformId="item.platform_id" />
				<span class="font-h6-medium ml-4 yx-color-text-primary">{{ item.anchor_name }}</span>
			</div>
			<p class="mt-2 font-h6-regular yx-color-text-secondary" v-if="$isPlatOr(item.platform_id, ['Dy', 'Ks'])">
				{{ item.platform_id | formatPlatformName('unify') }}：{{ item.anchor_account }}
			</p>
			<p class="mt-2 font-h6-regular yx-color-text-secondary" v-if="$isSp(item.platform_id)">
				{{ item.platform_id | formatPlatformName('unify') }}：{{ item.video_no || '-' }}
			</p>
			<p class="font-h6-regular yx-color-text-secondary">粉丝量：{{ item.fans_num }}</p>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
	},
	components: {},
};
</script>
<style lang="less" scoped>
.fan {
	flex: 1;
	white-space: nowrap;
	height: 20px;
	color: #fdd2a1;
	font-size: 12px;
	padding: 1px 2px;
	margin-left: 5px;
	border: 1px solid #fdd2a1;
}
</style>
